export const meta = {
  scriptId: 'ze-snippet',
  scriptHost: 'https://static.zdassets.com',
  scriptSrc() {
    let apiKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : process.env.ORION_WEB_ZENDESK_API_KEY ?? process.env.REACT_APP_ORION_WEB_ZENDESK_API_KEY;
    if (!apiKey) {
      throw new Error('Zendesk requires an API key');
    }
    return `${meta.scriptHost}/ekr/snippet.js?key=${apiKey}`;
  }
};